import { makeStyles } from "tss-react/mui";

const useItemsListStyles = makeStyles()((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "16px 16px",
  },
  listContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    paddingBottom: "16px",
    fontWeight: "500",
    color: theme.palette.text.accent,
  },
  list: {
    "& .list-rows:last-child": {
      borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
    },

    // "& .list-rows:nth-child(1)": {
    //   borderTop: "none",
    // },
  },
  listElements: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    borderBottom: "none",
    padding: "10px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.surface.light,
    fontSize: theme.typography.fontSize,
  },
  search: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    borderBottom: "none",
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    padding: "4px",
    backgroundColor: theme.palette.surface.light,
  },
  showButton: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    borderTop: "none",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    padding: "10px",
    textAlign: "center",
    backgroundColor: theme.palette.surface.light,
  },
  actionButton: {
    display: "flex",
    gap: "5px",
    justifyContent: "space-between",
  },
  logo: {
    textAlign: "center",
  },
}));

export default useItemsListStyles;
